export default {
  en: {
    title: 'Calls history',
    subtitle: 'List of calls.',
    columns: {
      agent: 'Agent',
      department: 'Department',
      date: 'Date',
      transferred: 'Transferred',
      resolved: 'Resolved',
    },
    agentDeleted: 'Agent was deleted',
    departmentDeleted: 'Department was deleted',
  },
  es: {
    title: 'Historial de llamadas',
    subtitle: 'Listado de llamados.',
    columns: {
      agent: 'Agente',
      department: 'Departamento',
      date: 'Fecha',
      transferred: 'Transferido',
      resolved: 'Resuelto',
    },
    agentDeleted: 'El agente fue eliminado',
    departmentDeleted: 'El departamento fue eliminado',
  },
};
